import script from "./GameRow.vue?vue&type=script&setup=true&lang=js"
export * from "./GameRow.vue?vue&type=script&setup=true&lang=js"

import "./GameRow.vue?vue&type=style&index=0&id=7c4b3fa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4b3fa2"]])

export default __exports__